import React from "react";

import {
  OperatorUserDetailsWidget
} from "@auto/users/__OperatorUserDetailsWidget";

/*
 * Developer-owned composition point for operator_user_annex.
 */
const loadAnnex = async () => null;
const renderAnnex = () => null;

export const displayOperatorUser = (gui, id) => ({
  uuid: `operator-user-${id}`,
  view: () => (
    <OperatorUserDetailsWidget
      gui={gui}
      id={id}
      loadAnnex={loadAnnex}
      renderAnnex={renderAnnex}
    />
  )
});

export default displayOperatorUser;
